import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { AdditionalFreeItemService } from './../models/additionalfreeitems.service';
import { DriverSubscriptionModel } from './../models/driver-subscription.model';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-select-driver-subscription-popup',
  template: require('../views/select-driver-subscription-popup.component.html'),
  providers: [AdditionalFreeItemService]
})

export class SelectDriverSubscriptionPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  driverSubscriptionList: DriverSubscriptionModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('driverSubscriptionModal') public driverSubscriptionModal: any;

  constructor(private additionalFreeItemService: AdditionalFreeItemService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["driverName", "subscriptionName", "sharedVehicleGroup"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetDriverList();
    this.driverSubscriptionModal.show();
  }

  public hide(): void {
    this.driverSubscriptionModal.hide();
  }

  private GetDriverList() {
    this.isLoading = true;
    this.additionalFreeItemService.GetDriverSubscriptionList(this.DataListModel)
      .subscribe(
      res => {
        this.driverSubscriptionList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(driverSubscription: DriverSubscriptionModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ sharedVehicleDriverHashId: driverSubscription.sharedVehicleDriverHashId,driverName:driverSubscription.driverName });
    this.isLoading = false;
    this.hide();
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetDriverList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverList();
  }
  private OnSuccessSelect() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/additionalfreeitem/components/select-driver-subscription-popup.component.ts